import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const menuItems =
  "font-sinkin text-xs text-white hover:text-site-yellow uppercase tracking-wider hover:underline"
const menuItemsDrop =
  "font-sinkin text-xs text-white hover:text-site-yellow uppercase tracking-wider"
const menuItemsPop =
  "font-sinkin text-sm text-white hover:text-site-yellow uppercase tracking-wider hover:underline"
const menuItemsButton =
  "font-sinkin bg-site-yellow hover:bg-white text-sm text-white hover:text-site-yellow font-medium uppercase tracking-wider rounded-sm py-2 px-4"

const MenuItemsUpdate = () => {
  const data = useStaticQuery(graphql`
    query MenuItemsUpdateQuery {
      prismicGeneralSettings {
        data {
          header_menu_list {
            menu_name
            menu_link {
              uid
            }
          }
          button_menu_name
          button_menu_link {
            uid
          }
        }
      }
    }
  `)

  const doc = data.prismicGeneralSettings

  return (
    <ul className="hidden xl:flex flex-grow items-center justify-center flex-wrap space-x-8 2xl:space-x-12">
      {doc.data.header_menu_list.map((item, index) => {
        return (
          <Link
            to={
              item.menu_link.uid
                ? `/${item.menu_link.uid}`
                : "/"
            }
          >
            <li className={menuItems}>
              {item.menu_name
                ? item.menu_name
                : "Menu Name"}
            </li>
          </Link>
        )
      })}
    </ul>
  )
}

export default MenuItemsUpdate
